import type { App } from 'vue';
import router from 'src/router';

export const installVueRouterPlugin = (app: App) => {
  app.use(router);
};
